var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.inNetwork ? 'grey lighten-4' : 'primary',"x-small":""},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.inNetwork ? 'Block from Network' : 'Add to Network')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }